import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ContainerContext } from '../../../../../common/container/ContainerContext';
import { observer } from 'mobx-react';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { IUserPageProperties } from '../../IUserPageProperties';
import { ProjectFormDomain } from '../../project/form/store/ProjectFormDomain';
import { ApplicationInfoContent } from './parts/ApplicationInfoContent';
import { ApplicationDetailDomain } from './store/ApplicationDetailDomain';
import { ApplicationDetailsMode } from './store/ApplicationDetailsMode';
import { ApplicationDetailsType } from './store/ApplicationDetailsType';

export interface IApplicationEditProperties extends IUserPageProperties {
  projectFormDomain?: ProjectFormDomain;
}

export const ApplicationEdit = observer(({ layoutDomain, projectFormDomain }: IApplicationEditProperties) => {
  const container = useContext(ContainerContext);
  const classes = useStyles();
  const [domain] = useState(new (container.get(ApplicationDetailDomain))(layoutDomain));
  const { applicationId = undefined, projectId = undefined } = useParams<any>();

  useEffect(() => {
    domain.startPage(
      container,
      ApplicationDetailsMode.edit,
      applicationId,
      projectId,
      ApplicationDetailsType.entity,
      projectFormDomain,
    );
  }, [domain, applicationId, projectId, projectFormDomain, projectFormDomain?.ui.model.entity.id, container]);

  return (
    <Grid container direction="row" justifyContent="center" alignItems="flex-start" className={classes.pageContainer}>
      <Grid item xs={12} className={classes.contentContainer}>
        <ApplicationInfoContent domain={domain} />
      </Grid>
    </Grid>
  );
});

const useStyles = makeStyles(() => ({
  pageContainer: {
    height: '100%',
    overflow: 'hidden',
    minHeight: 0,
  },
  contentContainer: {
    height: '100%',
    overflow: 'hidden',
    minHeight: 0,
  },
}));
